import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "./use-api-client";

export const useIsAdmin = () => {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: ["is-admin"],
        queryFn: async () => {
            const response = await apiClient.get("/is-admin");

            if (!response.ok) {
                // If we get a 401, the user is not an admin
                if (response.status === 401) {
                    return false;
                }
                throw new Error("Failed to check admin status");
            }

            return (await response.json()).isAdmin as boolean;
        },
        retry: false,
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });
};
